module.exports = __webpack_public_path__ + "img/logo-agentik.47fbc4d6.png";